export enum EstimatePlansTakeOffsActions {
    Upload = 'Upload a plan',
    Scale = 'Scale plans',
    Faqs = 'FAQs',
}
